import {array, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {stringOptionalNullable} from '@shared/utils';

export const participantV8nSchema = object().shape({
  participant_id: string().required(),
  names: array().of(string().required()).required(),
  default_name: stringOptionalNullable,
  localized_name: object().required(),
  category_slug: string().required(),
  subcategory_slug: stringOptionalNullable,
  colors: array().of(string().required()).nullable().optional(),
  abbreviation: stringOptionalNullable,
  nation: stringOptionalNullable,
  external_participant_ids: array()
    .of(string().required())
    .nullable()
    .optional(),
  logo_url: stringOptionalNullable,
  logo_url_stroke: stringOptionalNullable,
  logo_url_player: stringOptionalNullable,
  logo_url_custom: stringOptionalNullable,
});

export const v8nSchemaOfGetParticipantsResponse = paginationV8nSchema.shape({
  array: array().of(participantV8nSchema),
});
